import { render } from "./Edit.vue?vue&type=template&id=2b65886a&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=2b65886a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b65886a"],['__file',"src/views/AutoGenerate/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b65886a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b65886a', __exports__)) {
    api.reload('2b65886a', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=2b65886a&scoped=true", () => {
    api.rerender('2b65886a', render)
  })

}


export default __exports__